import propTypes from 'prop-types'
import { FaImage, FaTimes, FaVolumeUp } from 'react-icons/fa'
import classNames from 'classnames'
import Loader from 'components/Loader'


export default function AlbumItemThumb(props) {
  const thumbnail = props.file?.thumbnail
  const blob = props.file?.blob
  const file = props.file?.file
  const _type = props.file?.type
  const small = props.file?.small
  const medium = props.file?.medium
  const status = props.file?.jobStatus

  let element = null

  if (
    _type === 'Image' || (
      _type === 'Video' &&
      thumbnail &&
      !props.videoThumbnail
    )
  ) {
    element = <img
      className='w-full h-full object-cover'
      src={(_type === 'Video' && thumbnail) || small || medium || file}
      alt={props.file.title}
    />
  } else if (_type === 'Video') {
    element = <video
      disableRemotePlayback
      loop
      className='w-full h-full object-cover'
      muted
      autoPlay
      src={blob || small || medium || file}
    />
  } else if (_type === 'Audio') {
    element = <div className='bg-disabled-400 w-full h-full flex items-center justify-center text-2xl w-full h-full'>
      <FaVolumeUp />
    </div>
  } else {
    element = <div className='bg-disabled-400 w-full h-full flex items-center justify-center text-2xl w-full h-full'>
      <FaImage />
    </div>
  }

  return (
    <div
      draggable={false}
      className={classNames([
        'aspect-w-1 aspect-h-1 select-none pointer-events-none relative',
        props.className,
      ])}
    >
      { props.overlay }
      {element}
      <Loader
        containerClassName='bg-black bg-opacity-50'
        className='w-10 h-10 text-white'
        center
        active={status === 'pending' || status === 'processing'}
      />
      {
        status === 'error' &&
        <div className='
          bg-danger-600 bg-opacity-60 text-white
          absolute left-0 top-0 text-2xl
          flex flex-col items-center justify-center
        '>
          <FaTimes />
          Error
        </div>
      }
    </div>
  )
}


AlbumItemThumb.propTypes = {
  file: propTypes.object,
  overlay: propTypes.object,
  className: propTypes.string,
  videoThumbnail: propTypes.bool,
}
